import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/cars')({
    component: Outlet,
    staticData: {
        crumb: {
            label: 'Cars',
        }
    }
})